/**
 * @generated SignedSource<<9cfd24d5a7b254da9df2b7818b0476d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CorpTypeEnum = "CORPS" | "INDIS";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type LoginType = "CommonCert" | "HometaxId" | "Kakao" | "Naver" | "PartnerCert";
export type Certificate = {
  signCert: string;
  signPri: string;
  signPw: string;
};
export type HometaxAccount = {
  id: string;
  password: string;
  resno?: string | null | undefined;
};
export type SimpleAuth = {
  token: string;
};
export type checkHometaxAccountMutation$variables = {
  certificate?: Certificate | null | undefined;
  corpType: CorpTypeEnum;
  hometaxAccount?: HometaxAccount | null | undefined;
  hometaxCookies?: string | null | undefined;
  loginType: LoginType;
  simpleAuth?: SimpleAuth | null | undefined;
  tin?: string | null | undefined;
};
export type checkHometaxAccountMutation$data = {
  readonly checkHometaxAccount: {
    readonly email: string | null | undefined;
    readonly errors: {
      readonly code: ErrorType;
    } | null | undefined;
    readonly lastLoginType: string | null | undefined;
    readonly refundToken: string | null | undefined;
    readonly result: boolean;
  };
};
export type checkHometaxAccountMutation = {
  response: checkHometaxAccountMutation$data;
  variables: checkHometaxAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "certificate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "corpType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hometaxAccount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hometaxCookies"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loginType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "simpleAuth"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tin"
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "certificate",
        "variableName": "certificate"
      },
      {
        "kind": "Variable",
        "name": "corpType",
        "variableName": "corpType"
      },
      {
        "kind": "Variable",
        "name": "hometaxAccount",
        "variableName": "hometaxAccount"
      },
      {
        "kind": "Variable",
        "name": "hometaxCookies",
        "variableName": "hometaxCookies"
      },
      {
        "kind": "Variable",
        "name": "loginType",
        "variableName": "loginType"
      },
      {
        "kind": "Variable",
        "name": "simpleAuth",
        "variableName": "simpleAuth"
      },
      {
        "kind": "Variable",
        "name": "tin",
        "variableName": "tin"
      }
    ],
    "concreteType": "CheckHometaxAccountOutput",
    "kind": "LinkedField",
    "name": "checkHometaxAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refundToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastLoginType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "checkHometaxAccountMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "checkHometaxAccountMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "9b7593bfc460422d45c471d5de3f1e10",
    "id": null,
    "metadata": {},
    "name": "checkHometaxAccountMutation",
    "operationKind": "mutation",
    "text": "mutation checkHometaxAccountMutation(\n  $corpType: CorpTypeEnum!\n  $loginType: LoginType!\n  $certificate: Certificate\n  $hometaxAccount: HometaxAccount\n  $hometaxCookies: String\n  $simpleAuth: SimpleAuth\n  $tin: String\n) {\n  checkHometaxAccount(corpType: $corpType, loginType: $loginType, certificate: $certificate, hometaxAccount: $hometaxAccount, hometaxCookies: $hometaxCookies, simpleAuth: $simpleAuth, tin: $tin) {\n    result\n    errors {\n      code\n    }\n    refundToken\n    email\n    lastLoginType\n  }\n}\n"
  }
};
})();

(node as any).hash = "363f2d33fc5784d7cae8ee472fad227a";

export default node;
